export default __webpack_public_path__ + "static/media/2fa_phone.e7f07739.png";